import { Button } from "antd";

export function PillButton({
  title,
  onClick,
  color,
  backgroundColor,
  id,
  disabled,
  loading,
}: {
  disabled?: boolean;
  loading?: boolean;
  id?: string;
  title: string;
  onClick: () => void;
  color?: string;
  backgroundColor?: string;
}) {
  return (
    <Button
      id={id}
      loading={loading}
      type="text"
      onClick={onClick}
      style={{
        borderRadius: 20,
        backgroundColor: backgroundColor ?? "var(--exhut-total-green)",
        color: color ?? "white",
      }}
      disabled={disabled}
    >
      {title}
    </Button>
  );
}
